module.exports = __webpack_public_path__ + "media/images/homes/Inbuild_Themes@2x-03434f7afb1703bce7fdac204756bea5.png";